import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';

try {
  i18n
    .use(HttpApi)
    .use(initReactI18next)
    .init({
      lng: 'en',
      fallbackLng: 'en',
      backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
      },
      ns: ['translation', 'profile'],
      defaultNS: 'translation',
      debug: false, // Set to true for debugging
      interpolation: {
        escapeValue: false, // React already escapes values
      },
    });
} catch (error) {
  console.error('i18n initialization error:', error);
}

export default i18n;
